import { FC } from 'react';
import { SkeletonRect } from '../SkeletonRect';
import { clsx } from 'clsx';
import styles from './SkeletonItemMobile.css';

interface ISkeletonItemMobileProps {
  isWide: boolean;
}

export const SkeletonItemMobile: FC<ISkeletonItemMobileProps> = ({ isWide }) => {
  return (
    <div className={styles['skeleton-item']}>
      <div className={clsx(styles['gallery'], isWide && styles['gallery--wide'])}>
        {/** Фото */}
        <SkeletonRect height="100%" style={{ height: '100%' }} borderRadius={4} className={styles['photo']} />

        {/** Миниатюры фото */}
        {isWide && (
          <div className={styles['thumbnails']}>
            <SkeletonRect height={60} borderRadius={4} />
            <SkeletonRect height={60} borderRadius={4} />
            <SkeletonRect height={60} borderRadius={4} />
          </div>
        )}
      </div>

      <div className={styles['publisher']}>
        <SkeletonRect height={40} width={40} borderRadius={4} className={styles['avatar']} />
        <SkeletonRect height={24} borderRadius={4} className={styles['name']} />
        <SkeletonRect height={16} borderRadius={4} className={styles['agent-type']} />
      </div>

      <div className={styles['content']}>
        {/** Лейблы */}
        <div className={styles['labels']}>
          <SkeletonRect height={24} width={120} />
          <SkeletonRect height={24} width={80} />
        </div>
        {/** Заголовок */}
        <SkeletonRect height={24} className={styles['title']} />
        {/** Цена */}
        <SkeletonRect height={28} width={144} className={styles['price']} />
        {/** Подзаголовок */}
        <SkeletonRect height={22} className={styles['subtitle']} />
        {/** Гео */}
        <div className={styles['geo']}>
          <SkeletonRect height={20} />
          <SkeletonRect height={20} />
          <SkeletonRect height={20} />
        </div>
        {/** Адрес */}
        <SkeletonRect height={40} className={styles['address']} />
        {/** Кнопки */}
        <div className={styles['buttons']}>
          <SkeletonRect height={40} />
          <SkeletonRect height={40} />
        </div>
      </div>
    </div>
  );
};
